import { WebClient } from "@cisco/spaces-dash-lib-web";

// const DOMAIN = "http://localhost:8088";
const API_PREFIX = "/api/v1";
const PARTNER_LICENSE_INFO = "/partnerapps/license/info";
const GET_DASHBOARD_PROPERTIES = "/client/properties";
const END_USER_LICENSE_AGREEMENT = "/partnerapps/doc/license";
const ADVANCE_PARTNER = "/partnerapps/advancePartner";
const ACTIVATION_COUNT = "/partnerapps/appLevelCumulativeActivation";
const GET_PARTNER_APP_DETAILS = "/partnerapps/getApp";
const GET_CUSTOMERS_AND_ACTIVATIONS = "/partnerapps/activation/customer";
const STOP_TRACE = "/partnerapps/firehose/stopTrace";
const PARTNER_APPS_LIST = "/partnerapps/list";
const PARTNER_EVENTS_LIST = "/partnerapps/events";
const PARTNER_CATEGORIES_LIST = "/partnerapps/filters";
const FILE_UPLOAD_TO_S3 = "/partner/uploadImage";
const READ_FILE_FROM_S3 = "/partnerapps/readS3File";
const PARTNER_APPS_SAVE = "/partnerapps/save";
const DELETE_APPS = "/partnerapps/deleteApps";
const MAKE_DRAFT_VERSION = "/partnerapps/makeDraftVersion";
const PARTNER_STAGE_UPDATE = "/partnerapps/partnerStageUpdate";
const ENABLE_PARTNER_STATUS = "/partnerapps/enablePartnerStatus";
const RBAC_USERS = "/partnerrbac/users";
const RBAC_ROLES = "/partnerrbac/roles";
const RBAC_ROLE_UPDATE = "/partnerrbac/role/update";
const GET_ACCESS_TOKEN = "/partnerapps/oauth/accessToken";
const OAUTH_CUSTOMER_INFO = "/partnerapps/oauth/appInfo";
const ACTIVATE_APP = "/partnerapps/activateApp";
const SAVE_CUSTOMER_INFO = "/partnerapps/savePartnerCustomerInfo";
const GET_ON_BOARD_STATUS = "/partnerapps/getOnboardingStatus";
const SET_ON_BOARD_STATUS = "/partnerapps/setOnboardingStatus";
const GET_ALL_ACTIVATION_DETAILS = "/partnerapps/getAllActivationDetails";
const GET_KEY_RENEW_ROTATION = "/partnerapps/regenerateAPIKey";
const SEND_EMAIL_NOTIFICATION = "/email/partner/send";

const OPTIONS = {
  credentials: "include",
  mode: "cors",
  cache: "no-cache",
  redirect: "follow",
  referrerPolicy: "no-referrer",
  headers: {
    Accept: "application/json"
  }
};

const IMG_OPTIONS = {
  credentials: "include",
  mode: "cors",
  cache: "no-cache",
  redirect: "follow",
  referrerPolicy: "no-referrer"
};

const FILE_UPLOAD_OPTIONS = {
  credentials: "include",
  mode: "cors",
  cache: "no-cache",
  redirect: "follow",
  referrerPolicy: "no-referrer",
  headers: {
    "content-type": "multipart/form-data"
  }
};

const getSandboxParamUrl = (url, type, postParams) => {
  if (type === "get") {
    let modifiedUrl = url;
    if (url.indexOf("?") > -1) {
      modifiedUrl += "&isSandbox=true";
    } else {
      modifiedUrl += "?isSandbox=true";
    }
    return modifiedUrl;
  }
  let modifiedParams;
  if (postParams) {
    modifiedParams = { ...postParams, isSandbox: true };
  } else {
    modifiedParams = {
      isSandbox: true
    };
  }
  return modifiedParams;
};

export const getLicenseInfo = (tenantId, region) => {
  let url = `${API_PREFIX}${PARTNER_LICENSE_INFO}?tenantId=${tenantId}&region=${region}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getEndUserLicenseAgreement = () => {
  let url = `${API_PREFIX}${END_USER_LICENSE_AGREEMENT}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getDashboardProperties = () => {
  return WebClient.get(`${API_PREFIX}${GET_DASHBOARD_PROPERTIES}?t=${new Date().getTime()}`, OPTIONS);
};

export const isAdvancePartner = () => {
  let url = `${API_PREFIX}${ADVANCE_PARTNER}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getAppLevelCumulativeActivation = () => {
  let url = `${API_PREFIX}${ACTIVATION_COUNT}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getAppDetails = (id) => {
  const url = `${API_PREFIX}${GET_PARTNER_APP_DETAILS}`;
  let body = {
    appId: id
  };
  body = getSandboxParamUrl(url, "post", body);
  return WebClient.post(url, OPTIONS, body);
};

export const getCustomersAndActivations = (appId) => {
  let url = `${API_PREFIX}${GET_CUSTOMERS_AND_ACTIVATIONS}?appId=${appId}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const stopTrace = (uuid) => {
  const url = `${API_PREFIX}${STOP_TRACE}?uniqueId=${uuid}`;
  return WebClient.get(url, OPTIONS);
};

export const getPartnerAppsList = (region, isSandbox) => {
  const url = `${API_PREFIX}${PARTNER_APPS_LIST}?region=${region}&isSandbox=${isSandbox}`;
  return WebClient.get(url, OPTIONS);
};

export const getPartnerEventsList = (isSandbox) => {
  const url = `${API_PREFIX}${PARTNER_EVENTS_LIST}?isSandbox=${isSandbox}`;
  return WebClient.get(url, OPTIONS);
};

export const getPartnerCategories = (isSandbox) => {
  const url = `${API_PREFIX}${PARTNER_CATEGORIES_LIST}?subCategories=true&isSandbox=${isSandbox}`;
  return WebClient.get(url, OPTIONS);
};

export const fileUploadToS3 = (imageData) => {
  const url = `${API_PREFIX}${FILE_UPLOAD_TO_S3}`;

  return WebClient.post(url, FILE_UPLOAD_OPTIONS, imageData);
};

export const readFileFromS3 = (imageData) => {
  const url = `${API_PREFIX}${READ_FILE_FROM_S3}`;

  return WebClient.post(url, IMG_OPTIONS, imageData);
};

export const savePartnerApp = (appData) => {
  const url = `${API_PREFIX}${PARTNER_APPS_SAVE}`;

  return WebClient.post(url, OPTIONS, appData);
};

export const deleteApp = (appObj) => {
  const url = `${API_PREFIX}${DELETE_APPS}`;

  return WebClient.post(url, OPTIONS, appObj);
};

export const makeDraftVersion = (appObj) => {
  const url = `${API_PREFIX}${MAKE_DRAFT_VERSION}`;

  return WebClient.post(url, OPTIONS, appObj);
};

export const partnerStageUpdate = (stageObj) => {
  const url = `${API_PREFIX}${PARTNER_STAGE_UPDATE}`;

  return WebClient.post(url, OPTIONS, stageObj);
};

export const enablePartnerStatus = (region, isSandbox) => {
  const url = `${API_PREFIX}${ENABLE_PARTNER_STATUS}?region=${region}&isSandbox=${isSandbox}`;
  return WebClient.get(url, OPTIONS);
};

export const getRBACUsers = () => {
  let url = `${API_PREFIX}${RBAC_USERS}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getRBACRoles = () => {
  let url = `${API_PREFIX}${RBAC_ROLES}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const updateRBACUserRole = (roleObj) => {
  const url = `${API_PREFIX}${RBAC_ROLE_UPDATE}`;
  const updatedRoleObj = getSandboxParamUrl(url, "post", roleObj);
  return WebClient.post(url, OPTIONS, updatedRoleObj);
};

export const getOauthAccessToken = (param) => {
  const url = `${API_PREFIX}${GET_ACCESS_TOKEN}`;
  let oauthObj = param;
  oauthObj = getSandboxParamUrl(url, "post", oauthObj);
  return WebClient.post(url, OPTIONS, oauthObj);
};

export const getOauthCustomerDetails = (config) => {
  const url = `${API_PREFIX}${OAUTH_CUSTOMER_INFO}`;
  const conf = getSandboxParamUrl(url, "post", config);
  return WebClient.post(url, OPTIONS, conf);
};

export const activatePartnerApp = (param) => {
  let config = param;
  const url = `${API_PREFIX}${ACTIVATE_APP}`;
  config = getSandboxParamUrl(url, "post", config);
  return WebClient.post(url, OPTIONS, config);
};

export const savePartnerCustomerInformation = (param) => {
  let config = param;
  const url = `${API_PREFIX}${SAVE_CUSTOMER_INFO}`;
  config = getSandboxParamUrl(url, "post", config);
  return WebClient.post(url, OPTIONS, config);
};

export const getOnBoardStatus = () => {
  let url = `${API_PREFIX}${GET_ON_BOARD_STATUS}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const setOnBoardStatus = () => {
  let url = `${API_PREFIX}${SET_ON_BOARD_STATUS}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getAllActivationDetails = (appId) => {
  let url = `${API_PREFIX}${GET_ALL_ACTIVATION_DETAILS}/${appId}`;
  url = getSandboxParamUrl(url, "get", {});
  return WebClient.get(url, OPTIONS);
};

export const getKeyRotationRenew = (keyObj) => {
  let config = keyObj;
  const url = `${API_PREFIX}${GET_KEY_RENEW_ROTATION}`;
  config = getSandboxParamUrl(url, "post", config);
  return WebClient.post(url, OPTIONS, config);
};

export const sendMail = (emailDetails) => {
  const url = `${API_PREFIX}${SEND_EMAIL_NOTIFICATION}`;
  const updatedEmailDetails = getSandboxParamUrl(url, "post", emailDetails);
  return WebClient.post(url, OPTIONS, updatedEmailDetails);
};
